import { createContext } from 'react';

import { Context } from '../../../types';
import { ServiceAddressToOption } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<ServiceAddressToOption>>(getContextDefaultValues(api));
